export default {
  DONT: 1,
  Infrequently: 3,
  TryingToStop: 8,
  Smoke: 9,
};
